import buildMeta from '@/router/utils/buildMeta'

const routes = [
  {
    name: 'coach-admin',
    path: '/coach',
    component: () => import('@/pages/Domain/Views/Analytics.vue'),
    meta: buildMeta({
      authRequired: true,
      pageTitle: 'Coach Admin',
      title: 'Coach Admin - Jobscan',
    }),
  },
]

export default routes
